import { render, staticRenderFns } from "./add.vue?vue&type=template&id=bc7e9e54&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=bc7e9e54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7e9e54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7e9e54')) {
      api.createRecord('bc7e9e54', component.options)
    } else {
      api.reload('bc7e9e54', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=bc7e9e54&scoped=true", function () {
      api.rerender('bc7e9e54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemAdministrator/otherH5Page/components/add.vue"
export default component.exports